export default `/* Ids Layout Flex Component */
/* Ids Layout Flex Item Component */
:host([align-self=auto]),
.ids-layout-flex-item-align-self-auto {
  align-self: auto;
}

:host([align-self=baseline]),
.ids-layout-flex-item-align-self-baseline {
  align-self: baseline;
}

:host([align-self=center]),
.ids-layout-flex-item-align-self-center {
  align-self: center;
}

:host([align-self=stretch]),
.ids-layout-flex-item-align-self-stretch {
  align-self: stretch;
}

:host([align-self=flex-start]),
.ids-layout-flex-item-align-self-flex-start {
  align-self: flex-start;
}

:host([align-self=flex-end]),
.ids-layout-flex-item-align-self-flex-end {
  align-self: flex-end;
}

:host([grow="0"]),
.ids-layout-flex-item-grow-0 {
  flex-grow: 0;
}

:host([grow="1"]),
.ids-layout-flex-item-grow-1 {
  flex-grow: 1;
}

:host([grow="1"]) {
  min-height: 0;
}

:host([shrink="0"]),
.ids-layout-flex-item-shrink-0 {
  flex-shrink: 0;
}

:host([shrink="1"]),
.ids-layout-flex-item-shrink-1 {
  flex-shrink: 1;
}

:host([flex="1"]),
.ids-layout-flex-item-flex-1 {
  flex: 1;
}

:host([flex="2"]),
.ids-layout-flex-item-flex-2 {
  flex: 2;
}

:host([flex="3"]),
.ids-layout-flex-item-flex-3 {
  flex: 3;
}

:host([flex="4"]),
.ids-layout-flex-item-flex-4 {
  flex: 4;
}

:host([flex="5"]),
.ids-layout-flex-item-flex-5 {
  flex: 5;
}

:host([flex="6"]),
.ids-layout-flex-item-flex-6 {
  flex: 6;
}

:host([flex="7"]),
.ids-layout-flex-item-flex-7 {
  flex: 7;
}

:host([flex="8"]),
.ids-layout-flex-item-flex-8 {
  flex: 8;
}

:host([flex="9"]),
.ids-layout-flex-item-flex-9 {
  flex: 9;
}

:host([flex="10"]),
.ids-layout-flex-item-flex-10 {
  flex: 10;
}

:host([flex="11"]),
.ids-layout-flex-item-flex-11 {
  flex: 11;
}

:host([flex="12"]),
.ids-layout-flex-item-flex-12 {
  flex: 12;
}

:host([flex="13"]),
.ids-layout-flex-item-flex-13 {
  flex: 13;
}

:host([flex="14"]),
.ids-layout-flex-item-flex-14 {
  flex: 14;
}

:host([flex="15"]),
.ids-layout-flex-item-flex-15 {
  flex: 15;
}

:host([flex="16"]),
.ids-layout-flex-item-flex-16 {
  flex: 16;
}

:host([flex="17"]),
.ids-layout-flex-item-flex-17 {
  flex: 17;
}

:host([flex="18"]),
.ids-layout-flex-item-flex-18 {
  flex: 18;
}

:host([flex="19"]),
.ids-layout-flex-item-flex-19 {
  flex: 19;
}

:host([flex="20"]),
.ids-layout-flex-item-flex-20 {
  flex: 20;
}

:host([flex="21"]),
.ids-layout-flex-item-flex-21 {
  flex: 21;
}

:host([flex="22"]),
.ids-layout-flex-item-flex-22 {
  flex: 22;
}

:host([flex="23"]),
.ids-layout-flex-item-flex-23 {
  flex: 23;
}

:host([flex="24"]),
.ids-layout-flex-item-flex-24 {
  flex: 24;
}

:host([overflow=auto]),
.ids-layout-flex-item-overflow-auto {
  overflow: auto;
}

:host([overflow=hidden]),
.ids-layout-flex-item-overflow-hidden {
  overflow: hidden;
}

:host([overflow=visible]),
.ids-layout-flex-item-overflow-visible {
  overflow: visible;
}

:host([overflow=scroll]),
.ids-layout-flex-item-overflow-scroll {
  overflow: scroll;
}

:host(.has-container-grid[grow="0"][shrink="0"]),
.ids-layout-flex-item.has-container-grid.ids-layout-flex-item-grow-0.ids-layout-flex-item-shrink-0 {
  width: 100%;
}

::slotted(ids-input[size=full]) {
  display: inline-block;
}

:host,
.ids-layout-flex {
  display: flex;
}

:host([hidden]) {
  display: none;
}

:host([display=inline-flex]),
.ids-layout-flex-display-inline-flex {
  display: inline-flex;
}

:host([align-content=flex-start]),
.ids-layout-flex-align-content-flex-start {
  align-content: flex-start;
}

:host([align-content=flex-end]),
.ids-layout-flex-align-content-flex-end {
  align-content: flex-end;
}

:host([align-content=center]),
.ids-layout-flex-align-content-center {
  align-content: center;
}

:host([align-content=space-between]),
.ids-layout-flex-align-content-space-between {
  align-content: space-between;
}

:host([align-content=space-around]),
.ids-layout-flex-align-content-space-around {
  align-content: space-around;
}

:host([align-content=space-evenly]),
.ids-layout-flex-align-content-space-evenly {
  align-content: space-evenly;
}

:host([align-content=stretch]),
.ids-layout-flex-align-content-stretch {
  align-content: stretch;
}

:host([align-content=start]),
.ids-layout-flex-align-content-start {
  align-content: start;
}

:host([align-content=end]),
.ids-layout-flex-align-content-end {
  align-content: end;
}

:host([align-content=baseline]),
.ids-layout-flex-align-content-baseline {
  align-content: baseline;
}

:host([align-items=start]),
.ids-layout-flex-align-items-start {
  align-items: start;
}

:host([align-items=end]),
.ids-layout-flex-align-items-end {
  align-items: end;
}

:host([align-items=flex-start]),
.ids-layout-flex-align-items-flex-start {
  align-items: flex-start;
}

:host([align-items=flex-end]),
.ids-layout-flex-align-items-flex-end {
  align-items: flex-end;
}

:host([align-items=center]),
.ids-layout-flex-align-items-center {
  align-items: center;
}

:host([align-items=baseline]),
.ids-layout-flex-align-items-baseline {
  align-items: baseline;
}

:host([align-items=stretch]),
.ids-layout-flex-align-items-stretch {
  align-items: stretch;
}

:host([align-items=center]),
:host([align-items=center-inputs]),
.ids-layout-flex-align-items-center-inputs {
  align-items: start;
}

:host([align-items=center]),
:host([align-items=center-inputs]) {
  --ids-checkbox-inline-min-height: var(--ids-input-height-30);
}
:host([align-items=center]) ::slotted(ids-layout-flex-item.has-checkbox),
:host([align-items=center-inputs]) ::slotted(ids-layout-flex-item.has-checkbox) {
  align-self: end;
}

:host([align-items=center][field-height=xs]),
:host([align-items=center-inputs][field-height=xs]) {
  --ids-checkbox-inline-min-height: var(--ids-input-height-10);
}

:host([align-items=center][field-height=sm]),
:host([align-items=center-inputs][field-height=sm]) {
  --ids-checkbox-inline-min-height: var(--ids-input-height-20);
}

:host([align-items=center][field-height=lg]),
:host([align-items=center-inputs][field-height=lg]) {
  --ids-checkbox-inline-min-height: var(--ids-input-height-40);
}

:host([direction=row]),
.ids-layout-flex-direction-row {
  flex-direction: row;
}

:host([direction=row-reverse]),
.ids-layout-flex-direction-row-reverse {
  flex-direction: row-reverse;
}

:host([direction=column]),
.ids-layout-flex-direction-column {
  flex-direction: column;
}

:host([direction=column-reverse]),
.ids-layout-flex-direction-column-reverse {
  flex-direction: column-reverse;
}

:host([justify-content=start]),
.ids-layout-flex-justify-content-start {
  justify-content: start;
}

:host([justify-content=stretch]),
.ids-layout-flex-justify-content-stretch {
  justify-content: stretch;
}

:host([justify-content=end]),
.ids-layout-flex-justify-content-end {
  justify-content: end;
}

:host([justify-content=flex-start]),
.ids-layout-flex-justify-content-flex-start {
  justify-content: flex-start;
}

:host([justify-content=flex-end]),
.ids-layout-flex-justify-content-flex-end {
  justify-content: flex-end;
}

:host([justify-content=center]),
.ids-layout-flex-justify-content-center {
  justify-content: center;
}

:host([justify-content=left]),
.ids-layout-flex-justify-content-left {
  justify-content: left;
}

:host([justify-content=right]),
.ids-layout-flex-justify-content-right {
  justify-content: right;
}

:host([justify-content=space-between]),
.ids-layout-flex-justify-content-space-between {
  justify-content: space-between;
}

:host([justify-content=space-around]),
.ids-layout-flex-justify-content-space-around {
  justify-content: space-around;
}

:host([justify-content=space-evenly]),
.ids-layout-flex-justify-content-space-evenly {
  justify-content: space-evenly;
}

:host([wrap=nowrap]),
.ids-layout-flex-wrap-nowrap {
  flex-wrap: nowrap;
}

:host([wrap=wrap]),
.ids-layout-flex-wrap-wrap {
  flex-wrap: wrap;
}

:host([wrap=wrap-reverse]),
.ids-layout-flex-wrap-wrap-reverse {
  flex-wrap: wrap-reverse;
}

:host([gap="0"]),
.ids-layout-flex-gap-0 {
  gap: 0px;
}

:host([gap="1"]),
.ids-layout-flex-gap-1 {
  gap: 1px;
}

:host([gap="2"]),
.ids-layout-flex-gap-2 {
  gap: 2px;
}

:host([gap="4"]),
.ids-layout-flex-gap-4 {
  gap: 4px;
}

:host([gap="8"]),
.ids-layout-flex-gap-8 {
  gap: 8px;
}

:host([gap="12"]),
.ids-layout-flex-gap-12 {
  gap: 12px;
}

:host([gap="16"]),
.ids-layout-flex-gap-16 {
  gap: 16px;
}

:host([gap="20"]),
.ids-layout-flex-gap-20 {
  gap: 20px;
}

:host([gap="24"]),
.ids-layout-flex-gap-24 {
  gap: 24px;
}

:host([gap="28"]),
.ids-layout-flex-gap-28 {
  gap: 28px;
}

:host([gap="32"]),
.ids-layout-flex-gap-32 {
  gap: 32px;
}

:host([gap="36"]),
.ids-layout-flex-gap-36 {
  gap: 36px;
}

:host([gap="40"]),
.ids-layout-flex-gap-40 {
  gap: 40px;
}

:host([gap-x="0"]),
.ids-layout-flex-gap-x-0 {
  row-gap: 0px;
}

:host([gap-x="1"]),
.ids-layout-flex-gap-x-1 {
  row-gap: 1px;
}

:host([gap-x="2"]),
.ids-layout-flex-gap-x-2 {
  row-gap: 2px;
}

:host([gap-x="4"]),
.ids-layout-flex-gap-x-4 {
  row-gap: 4px;
}

:host([gap-x="8"]),
.ids-layout-flex-gap-x-8 {
  row-gap: 8px;
}

:host([gap-x="12"]),
.ids-layout-flex-gap-x-12 {
  row-gap: 12px;
}

:host([gap-x="16"]),
.ids-layout-flex-gap-x-16 {
  row-gap: 16px;
}

:host([gap-x="20"]),
.ids-layout-flex-gap-x-20 {
  row-gap: 20px;
}

:host([gap-x="24"]),
.ids-layout-flex-gap-x-24 {
  row-gap: 24px;
}

:host([gap-x="28"]),
.ids-layout-flex-gap-x-28 {
  row-gap: 28px;
}

:host([gap-x="32"]),
.ids-layout-flex-gap-x-32 {
  row-gap: 32px;
}

:host([gap-x="36"]),
.ids-layout-flex-gap-x-36 {
  row-gap: 36px;
}

:host([gap-x="40"]),
.ids-layout-flex-gap-x-40 {
  row-gap: 40px;
}

:host([gap-y="0"]),
.ids-layout-flex-gap-y-0 {
  column-gap: 0px;
}

:host([gap-y="1"]),
.ids-layout-flex-gap-y-1 {
  column-gap: 1px;
}

:host([gap-y="2"]),
.ids-layout-flex-gap-y-2 {
  column-gap: 2px;
}

:host([gap-y="4"]),
.ids-layout-flex-gap-y-4 {
  column-gap: 4px;
}

:host([gap-y="8"]),
.ids-layout-flex-gap-y-8 {
  column-gap: 8px;
}

:host([gap-y="12"]),
.ids-layout-flex-gap-y-12 {
  column-gap: 12px;
}

:host([gap-y="16"]),
.ids-layout-flex-gap-y-16 {
  column-gap: 16px;
}

:host([gap-y="20"]),
.ids-layout-flex-gap-y-20 {
  column-gap: 20px;
}

:host([gap-y="24"]),
.ids-layout-flex-gap-y-24 {
  column-gap: 24px;
}

:host([gap-y="28"]),
.ids-layout-flex-gap-y-28 {
  column-gap: 28px;
}

:host([gap-y="32"]),
.ids-layout-flex-gap-y-32 {
  column-gap: 32px;
}

:host([gap-y="36"]),
.ids-layout-flex-gap-y-36 {
  column-gap: 36px;
}

:host([gap-y="40"]),
.ids-layout-flex-gap-y-40 {
  column-gap: 40px;
}

:host([full-height]),
.ids-layout-flex-full-height {
  height: 100%;
}

::slotted(ids-icon),
.ids-layout-flex > .ids-icon {
  display: inline-flex;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtbGF5b3V0LWZsZXgiLCJzb3VyY2VzIjpbImlkcy1sYXlvdXQtZmxleC5zY3NzIiwiaWRzLWxheW91dC1mbGV4LWl0ZW0uc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtBQ0FBO0FBTUU7QUFBQTtFQUVFLFlBTGM7OztBQUdoQjtBQUFBO0VBRUUsWUFMYzs7O0FBR2hCO0FBQUE7RUFFRSxZQUxjOzs7QUFHaEI7QUFBQTtFQUVFLFlBTGM7OztBQUdoQjtBQUFBO0VBRUUsWUFMYzs7O0FBR2hCO0FBQUE7RUFFRSxZQUxjOzs7QUFhaEI7QUFBQTtFQUVFLFdBTGE7OztBQUdmO0FBQUE7RUFFRSxXQUxhOzs7QUFTakI7RUFDRTs7O0FBT0E7QUFBQTtFQUVFLGFBTGU7OztBQUdqQjtBQUFBO0VBRUUsYUFMZTs7O0FBYWpCO0FBQUE7RUFFRSxNQUxROzs7QUFHVjtBQUFBO0VBRUUsTUFMUTs7O0FBR1Y7QUFBQTtFQUVFLE1BTFE7OztBQUdWO0FBQUE7RUFFRSxNQUxROzs7QUFHVjtBQUFBO0VBRUUsTUFMUTs7O0FBR1Y7QUFBQTtFQUVFLE1BTFE7OztBQUdWO0FBQUE7RUFFRSxNQUxROzs7QUFHVjtBQUFBO0VBRUUsTUFMUTs7O0FBR1Y7QUFBQTtFQUVFLE1BTFE7OztBQUdWO0FBQUE7RUFFRSxNQUxROzs7QUFHVjtBQUFBO0VBRUUsTUFMUTs7O0FBR1Y7QUFBQTtFQUVFLE1BTFE7OztBQUdWO0FBQUE7RUFFRSxNQUxROzs7QUFHVjtBQUFBO0VBRUUsTUFMUTs7O0FBR1Y7QUFBQTtFQUVFLE1BTFE7OztBQUdWO0FBQUE7RUFFRSxNQUxROzs7QUFHVjtBQUFBO0VBRUUsTUFMUTs7O0FBR1Y7QUFBQTtFQUVFLE1BTFE7OztBQUdWO0FBQUE7RUFFRSxNQUxROzs7QUFHVjtBQUFBO0VBRUUsTUFMUTs7O0FBR1Y7QUFBQTtFQUVFLE1BTFE7OztBQUdWO0FBQUE7RUFFRSxNQUxROzs7QUFHVjtBQUFBO0VBRUUsTUFMUTs7O0FBR1Y7QUFBQTtFQUVFLE1BTFE7OztBQWFWO0FBQUE7RUFFRSxVQUxZOzs7QUFHZDtBQUFBO0VBRUUsVUFMWTs7O0FBR2Q7QUFBQTtFQUVFLFVBTFk7OztBQUdkO0FBQUE7RUFFRSxVQUxZOzs7QUFXaEI7QUFBQTtFQUVFOzs7QUFHRjtFQUNFOzs7QUQ3REY7QUFBQTtFQUVFOzs7QUFHRjtFQUNFOzs7QUFHRjtBQUFBO0VBRUU7OztBQU9BO0FBQUE7RUFFRSxlQUxpQjs7O0FBR25CO0FBQUE7RUFFRSxlQUxpQjs7O0FBR25CO0FBQUE7RUFFRSxlQUxpQjs7O0FBR25CO0FBQUE7RUFFRSxlQUxpQjs7O0FBR25CO0FBQUE7RUFFRSxlQUxpQjs7O0FBR25CO0FBQUE7RUFFRSxlQUxpQjs7O0FBR25CO0FBQUE7RUFFRSxlQUxpQjs7O0FBR25CO0FBQUE7RUFFRSxlQUxpQjs7O0FBR25CO0FBQUE7RUFFRSxlQUxpQjs7O0FBR25CO0FBQUE7RUFFRSxlQUxpQjs7O0FBYW5CO0FBQUE7RUFFRSxhQUxlOzs7QUFHakI7QUFBQTtFQUVFLGFBTGU7OztBQUdqQjtBQUFBO0VBRUUsYUFMZTs7O0FBR2pCO0FBQUE7RUFFRSxhQUxlOzs7QUFHakI7QUFBQTtFQUVFLGFBTGU7OztBQUdqQjtBQUFBO0VBRUUsYUFMZTs7O0FBR2pCO0FBQUE7RUFFRSxhQUxlOzs7QUFTbkI7QUFBQTtBQUFBO0VBR0U7OztBQUdGO0FBQUE7RUFFRTs7QUFFQTtBQUFBO0VBQ0U7OztBQUlKO0FBQUE7RUFFRTs7O0FBR0Y7QUFBQTtFQUVFOzs7QUFHRjtBQUFBO0VBRUU7OztBQU9BO0FBQUE7RUFFRSxnQkFMa0I7OztBQUdwQjtBQUFBO0VBRUUsZ0JBTGtCOzs7QUFHcEI7QUFBQTtFQUVFLGdCQUxrQjs7O0FBR3BCO0FBQUE7RUFFRSxnQkFMa0I7OztBQWFwQjtBQUFBO0VBRUUsaUJBTG1COzs7QUFHckI7QUFBQTtFQUVFLGlCQUxtQjs7O0FBR3JCO0FBQUE7RUFFRSxpQkFMbUI7OztBQUdyQjtBQUFBO0VBRUUsaUJBTG1COzs7QUFHckI7QUFBQTtFQUVFLGlCQUxtQjs7O0FBR3JCO0FBQUE7RUFFRSxpQkFMbUI7OztBQUdyQjtBQUFBO0VBRUUsaUJBTG1COzs7QUFHckI7QUFBQTtFQUVFLGlCQUxtQjs7O0FBR3JCO0FBQUE7RUFFRSxpQkFMbUI7OztBQUdyQjtBQUFBO0VBRUUsaUJBTG1COzs7QUFHckI7QUFBQTtFQUVFLGlCQUxtQjs7O0FBYXJCO0FBQUE7RUFFRSxXQUxhOzs7QUFHZjtBQUFBO0VBRUUsV0FMYTs7O0FBR2Y7QUFBQTtFQUVFLFdBTGE7OztBQWNmO0FBQUE7RUFFRTs7O0FBRkY7QUFBQTtFQUVFOzs7QUFGRjtBQUFBO0VBRUU7OztBQUZGO0FBQUE7RUFFRTs7O0FBRkY7QUFBQTtFQUVFOzs7QUFGRjtBQUFBO0VBRUU7OztBQUZGO0FBQUE7RUFFRTs7O0FBRkY7QUFBQTtFQUVFOzs7QUFGRjtBQUFBO0VBRUU7OztBQUZGO0FBQUE7RUFFRTs7O0FBRkY7QUFBQTtFQUVFOzs7QUFGRjtBQUFBO0VBRUU7OztBQUZGO0FBQUE7RUFFRTs7O0FBTUY7QUFBQTtFQUVFOzs7QUFGRjtBQUFBO0VBRUU7OztBQUZGO0FBQUE7RUFFRTs7O0FBRkY7QUFBQTtFQUVFOzs7QUFGRjtBQUFBO0VBRUU7OztBQUZGO0FBQUE7RUFFRTs7O0FBRkY7QUFBQTtFQUVFOzs7QUFGRjtBQUFBO0VBRUU7OztBQUZGO0FBQUE7RUFFRTs7O0FBRkY7QUFBQTtFQUVFOzs7QUFGRjtBQUFBO0VBRUU7OztBQUZGO0FBQUE7RUFFRTs7O0FBRkY7QUFBQTtFQUVFOzs7QUFNRjtBQUFBO0VBRUU7OztBQUZGO0FBQUE7RUFFRTs7O0FBRkY7QUFBQTtFQUVFOzs7QUFGRjtBQUFBO0VBRUU7OztBQUZGO0FBQUE7RUFFRTs7O0FBRkY7QUFBQTtFQUVFOzs7QUFGRjtBQUFBO0VBRUU7OztBQUZGO0FBQUE7RUFFRTs7O0FBRkY7QUFBQTtFQUVFOzs7QUFGRjtBQUFBO0VBRUU7OztBQUZGO0FBQUE7RUFFRTs7O0FBRkY7QUFBQTtFQUVFOzs7QUFGRjtBQUFBO0VBRUU7OztBQUtKO0FBQUE7RUFFRTs7O0FBSUY7QUFBQTtFQUVFIiwic291cmNlc0NvbnRlbnQiOlsiLyogSWRzIExheW91dCBGbGV4IENvbXBvbmVudCAqL1xuQHVzZSAnLi9pZHMtbGF5b3V0LWZsZXgtaXRlbScgYXMgKjtcblxuOmhvc3QsXG4uaWRzLWxheW91dC1mbGV4IHtcbiAgZGlzcGxheTogZmxleDtcbn1cblxuOmhvc3QoW2hpZGRlbl0pIHtcbiAgZGlzcGxheTogbm9uZTtcbn1cblxuOmhvc3QoW2Rpc3BsYXk9J2lubGluZS1mbGV4J10pLFxuLmlkcy1sYXlvdXQtZmxleC1kaXNwbGF5LWlubGluZS1mbGV4IHtcbiAgZGlzcGxheTogaW5saW5lLWZsZXg7XG59XG5cbi8vIEFsaWduLWNvbnRlbnRcbiRhbGlnbi1jb250ZW50LWxpc3Q6IGZsZXgtc3RhcnQgZmxleC1lbmQgY2VudGVyIHNwYWNlLWJldHdlZW4gc3BhY2UtYXJvdW5kIHNwYWNlLWV2ZW5seSBzdHJldGNoIHN0YXJ0IGVuZCBiYXNlbGluZTtcblxuQGVhY2ggJGFsaWduLWNvbnRlbnQgaW4gJGFsaWduLWNvbnRlbnQtbGlzdCB7XG4gIDpob3N0KFthbGlnbi1jb250ZW50PScjeyRhbGlnbi1jb250ZW50fSddKSxcbiAgLmlkcy1sYXlvdXQtZmxleC1hbGlnbi1jb250ZW50LSN7JGFsaWduLWNvbnRlbnR9IHtcbiAgICBhbGlnbi1jb250ZW50OiAkYWxpZ24tY29udGVudDtcbiAgfVxufVxuXG4vLyBBbGlnbi1pdGVtc1xuJGFsaWduLWl0ZW1zLWxpc3Q6IHN0YXJ0IGVuZCBmbGV4LXN0YXJ0IGZsZXgtZW5kIGNlbnRlciBiYXNlbGluZSBzdHJldGNoO1xuXG5AZWFjaCAkYWxpZ24taXRlbXMgaW4gJGFsaWduLWl0ZW1zLWxpc3Qge1xuICA6aG9zdChbYWxpZ24taXRlbXM9JyN7JGFsaWduLWl0ZW1zfSddKSxcbiAgLmlkcy1sYXlvdXQtZmxleC1hbGlnbi1pdGVtcy0jeyRhbGlnbi1pdGVtc30ge1xuICAgIGFsaWduLWl0ZW1zOiAkYWxpZ24taXRlbXM7XG4gIH1cbn1cblxuOmhvc3QoW2FsaWduLWl0ZW1zPSdjZW50ZXInXSksXG46aG9zdChbYWxpZ24taXRlbXM9J2NlbnRlci1pbnB1dHMnXSksXG4uaWRzLWxheW91dC1mbGV4LWFsaWduLWl0ZW1zLWNlbnRlci1pbnB1dHMge1xuICBhbGlnbi1pdGVtczogc3RhcnQ7XG59XG5cbjpob3N0KFthbGlnbi1pdGVtcz0nY2VudGVyJ10pLFxuOmhvc3QoW2FsaWduLWl0ZW1zPSdjZW50ZXItaW5wdXRzJ10pIHtcbiAgLS1pZHMtY2hlY2tib3gtaW5saW5lLW1pbi1oZWlnaHQ6IHZhcigtLWlkcy1pbnB1dC1oZWlnaHQtMzApO1xuXG4gIDo6c2xvdHRlZChpZHMtbGF5b3V0LWZsZXgtaXRlbS5oYXMtY2hlY2tib3gpIHtcbiAgICBhbGlnbi1zZWxmOiBlbmQ7XG4gIH1cbn1cblxuOmhvc3QoW2FsaWduLWl0ZW1zPSdjZW50ZXInXVtmaWVsZC1oZWlnaHQ9J3hzJ10pLFxuOmhvc3QoW2FsaWduLWl0ZW1zPSdjZW50ZXItaW5wdXRzJ11bZmllbGQtaGVpZ2h0PSd4cyddKSB7XG4gIC0taWRzLWNoZWNrYm94LWlubGluZS1taW4taGVpZ2h0OiB2YXIoLS1pZHMtaW5wdXQtaGVpZ2h0LTEwKTtcbn1cblxuOmhvc3QoW2FsaWduLWl0ZW1zPSdjZW50ZXInXVtmaWVsZC1oZWlnaHQ9J3NtJ10pLFxuOmhvc3QoW2FsaWduLWl0ZW1zPSdjZW50ZXItaW5wdXRzJ11bZmllbGQtaGVpZ2h0PSdzbSddKSB7XG4gIC0taWRzLWNoZWNrYm94LWlubGluZS1taW4taGVpZ2h0OiB2YXIoLS1pZHMtaW5wdXQtaGVpZ2h0LTIwKTtcbn1cblxuOmhvc3QoW2FsaWduLWl0ZW1zPSdjZW50ZXInXVtmaWVsZC1oZWlnaHQ9J2xnJ10pLFxuOmhvc3QoW2FsaWduLWl0ZW1zPSdjZW50ZXItaW5wdXRzJ11bZmllbGQtaGVpZ2h0PSdsZyddKSB7XG4gIC0taWRzLWNoZWNrYm94LWlubGluZS1taW4taGVpZ2h0OiB2YXIoLS1pZHMtaW5wdXQtaGVpZ2h0LTQwKTtcbn1cblxuLy8gRGlyZWN0aW9uXG4kZmxleC1kaXJlY3Rpb24tbGlzdDogcm93IHJvdy1yZXZlcnNlIGNvbHVtbiBjb2x1bW4tcmV2ZXJzZTtcblxuQGVhY2ggJGZsZXgtZGlyZWN0aW9uIGluICRmbGV4LWRpcmVjdGlvbi1saXN0IHtcbiAgOmhvc3QoW2RpcmVjdGlvbj0nI3skZmxleC1kaXJlY3Rpb259J10pLFxuICAuaWRzLWxheW91dC1mbGV4LWRpcmVjdGlvbi0jeyRmbGV4LWRpcmVjdGlvbn0ge1xuICAgIGZsZXgtZGlyZWN0aW9uOiAkZmxleC1kaXJlY3Rpb247XG4gIH1cbn1cblxuLy8gSnVzdGlmeS1jb250ZW50XG4kanVzdGlmeS1jb250ZW50LWxpc3Q6IHN0YXJ0IHN0cmV0Y2ggZW5kIGZsZXgtc3RhcnQgZmxleC1lbmQgY2VudGVyIGxlZnQgcmlnaHQgc3BhY2UtYmV0d2VlbiBzcGFjZS1hcm91bmQgc3BhY2UtZXZlbmx5O1xuXG5AZWFjaCAkanVzdGlmeS1jb250ZW50IGluICRqdXN0aWZ5LWNvbnRlbnQtbGlzdCB7XG4gIDpob3N0KFtqdXN0aWZ5LWNvbnRlbnQ9JyN7JGp1c3RpZnktY29udGVudH0nXSksXG4gIC5pZHMtbGF5b3V0LWZsZXgtanVzdGlmeS1jb250ZW50LSN7JGp1c3RpZnktY29udGVudH0ge1xuICAgIGp1c3RpZnktY29udGVudDogJGp1c3RpZnktY29udGVudDtcbiAgfVxufVxuXG4vLyBXcmFwXG4kZmxleC13cmFwLWxpc3Q6IG5vd3JhcCB3cmFwIHdyYXAtcmV2ZXJzZTtcblxuQGVhY2ggJGZsZXgtd3JhcCBpbiAkZmxleC13cmFwLWxpc3Qge1xuICA6aG9zdChbd3JhcD0nI3skZmxleC13cmFwfSddKSxcbiAgLmlkcy1sYXlvdXQtZmxleC13cmFwLSN7JGZsZXgtd3JhcH0ge1xuICAgIGZsZXgtd3JhcDogJGZsZXgtd3JhcDtcbiAgfVxufVxuXG4vLyBVbml0c1xuJHVuaXRzOiAwIDEgMiA0IDggMTIgMTYgMjAgMjQgMjggMzIgMzYgNDA7XG5cbi8vIEdhcCBmb3IgYm90aCBob3Jpem9udGFsIGFuZCB2ZXJ0aWNhbFxuQGVhY2ggJGdhcCBpbiAkdW5pdHMge1xuICA6aG9zdChbZ2FwPScjeyRnYXB9J10pLFxuICAuaWRzLWxheW91dC1mbGV4LWdhcC0jeyRnYXB9IHtcbiAgICBnYXA6ICN7JGdhcH1weDtcbiAgfVxufVxuXG4vLyBIb3Jpem9udGFsIGdhcCAocm93LWdhcClcbkBlYWNoICRnYXAteCBpbiAkdW5pdHMge1xuICA6aG9zdChbZ2FwLXg9JyN7JGdhcC14fSddKSxcbiAgLmlkcy1sYXlvdXQtZmxleC1nYXAteC0jeyRnYXAteH0ge1xuICAgIHJvdy1nYXA6ICN7JGdhcC14fXB4O1xuICB9XG59XG5cbi8vIFZlcnRpY2FsIGdhcCAoY29sdW1uLWdhcClcbkBlYWNoICRnYXAteSBpbiAkdW5pdHMge1xuICA6aG9zdChbZ2FwLXk9JyN7JGdhcC15fSddKSxcbiAgLmlkcy1sYXlvdXQtZmxleC1nYXAteS0jeyRnYXAteX0ge1xuICAgIGNvbHVtbi1nYXA6ICN7JGdhcC15fXB4O1xuICB9XG59XG5cbi8vIEZ1bGwgSGVpZ2h0XG46aG9zdChbZnVsbC1oZWlnaHRdKSxcbi5pZHMtbGF5b3V0LWZsZXgtZnVsbC1oZWlnaHQge1xuICBoZWlnaHQ6IDEwMCU7XG59XG5cbi8vIEZpeCBpY29uc1xuOjpzbG90dGVkKGlkcy1pY29uKSxcbi5pZHMtbGF5b3V0LWZsZXggPiAuaWRzLWljb24ge1xuICBkaXNwbGF5OiBpbmxpbmUtZmxleDtcbn1cbiIsIi8qIElkcyBMYXlvdXQgRmxleCBJdGVtIENvbXBvbmVudCAqL1xuXG4vLyBBbGlnbi1zZWxmXG4kYWxpZ24tc2VsZi1saXN0OiBhdXRvIGJhc2VsaW5lIGNlbnRlciBzdHJldGNoIGZsZXgtc3RhcnQgZmxleC1lbmQ7XG5cbkBlYWNoICRhbGlnbi1zZWxmIGluICRhbGlnbi1zZWxmLWxpc3Qge1xuICA6aG9zdChbYWxpZ24tc2VsZj0nI3skYWxpZ24tc2VsZn0nXSksXG4gIC5pZHMtbGF5b3V0LWZsZXgtaXRlbS1hbGlnbi1zZWxmLSN7JGFsaWduLXNlbGZ9IHtcbiAgICBhbGlnbi1zZWxmOiAkYWxpZ24tc2VsZjtcbiAgfVxufVxuXG4vLyBGbGV4LWdyb3dcbiRmbGV4LWdyb3ctbGlzdDogMCAxO1xuXG5AZWFjaCAkZmxleC1ncm93IGluICRmbGV4LWdyb3ctbGlzdCB7XG4gIDpob3N0KFtncm93PScjeyRmbGV4LWdyb3d9J10pLFxuICAuaWRzLWxheW91dC1mbGV4LWl0ZW0tZ3Jvdy0jeyRmbGV4LWdyb3d9IHtcbiAgICBmbGV4LWdyb3c6ICRmbGV4LWdyb3c7XG4gIH1cbn1cblxuOmhvc3QoW2dyb3c9JzEnXSkge1xuICBtaW4taGVpZ2h0OiAwO1xufVxuXG4vLyBGbGV4LXNocmlua1xuJGZsZXgtc2hyaW5rLWxpc3Q6IDAgMTtcblxuQGVhY2ggJGZsZXgtc2hyaW5rIGluICRmbGV4LXNocmluay1saXN0IHtcbiAgOmhvc3QoW3Nocmluaz0nI3skZmxleC1zaHJpbmt9J10pLFxuICAuaWRzLWxheW91dC1mbGV4LWl0ZW0tc2hyaW5rLSN7JGZsZXgtc2hyaW5rfSB7XG4gICAgZmxleC1zaHJpbms6ICRmbGV4LXNocmluaztcbiAgfVxufVxuXG4vLyBGbGV4XG4kZmxleC1saXN0OiAxIDIgMyA0IDUgNiA3IDggOSAxMCAxMSAxMiAxMyAxNCAxNSAxNiAxNyAxOCAxOSAyMCAyMSAyMiAyMyAyNDtcblxuQGVhY2ggJGZsZXggaW4gJGZsZXgtbGlzdCB7XG4gIDpob3N0KFtmbGV4PScjeyRmbGV4fSddKSxcbiAgLmlkcy1sYXlvdXQtZmxleC1pdGVtLWZsZXgtI3skZmxleH0ge1xuICAgIGZsZXg6ICRmbGV4O1xuICB9XG59XG5cbi8vIE92ZXJmbG93XG4kb3ZlcmZsb3ctbGlzdDogYXV0byBoaWRkZW4gdmlzaWJsZSBzY3JvbGw7XG5cbkBlYWNoICRvdmVyZmxvdyBpbiAkb3ZlcmZsb3ctbGlzdCB7XG4gIDpob3N0KFtvdmVyZmxvdz0nI3skb3ZlcmZsb3d9J10pLFxuICAuaWRzLWxheW91dC1mbGV4LWl0ZW0tb3ZlcmZsb3ctI3skb3ZlcmZsb3d9IHtcbiAgICBvdmVyZmxvdzogJG92ZXJmbG93O1xuICB9XG59XG5cbi8vIGdyb3cvc2hyaW5rPTAgb3ZlcnJpZGUgLSBjbGFzcy1iYXNlZCB3b3JrYXJvdW5kIGZvciBjb250YWluZXIgZ3JpZCBjb2xsYXBzZVxuLy8gTm90ZTogOmhhcyg6OnNsb3R0ZWQoKSkgaXMgaW52YWxpZCBDU1MgZHVlIHRvIFNoYWRvdyBET00gc3BlYyBsaW1pdGF0aW9uc1xuOmhvc3QoLmhhcy1jb250YWluZXItZ3JpZFtncm93PScwJ11bc2hyaW5rPScwJ10pLFxuLmlkcy1sYXlvdXQtZmxleC1pdGVtLmhhcy1jb250YWluZXItZ3JpZC5pZHMtbGF5b3V0LWZsZXgtaXRlbS1ncm93LTAuaWRzLWxheW91dC1mbGV4LWl0ZW0tc2hyaW5rLTAge1xuICB3aWR0aDogMTAwJTtcbn1cblxuOjpzbG90dGVkKGlkcy1pbnB1dFtzaXplPVwiZnVsbFwiXSkge1xuICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG59XG4iXX0= */`;
